import { Box, Stack, Typography } from "@mui/material";
import { CustomeDialog, CustomTable } from "../../../shared";
import { createColumnHelper } from "@tanstack/react-table";
import editIcon from "../../../assets/images/Icons/editIcon.png";
import { useBatchGroup } from "../hooks/useBatchGroup";
import { BatchColourCodeDialog } from "./BatchColourcodeDialog";

export const BatchGroup = () => {
  const {
    batchGroup,
    handleColourChange,
    onUpdateBatchColour,
    listQuery,
    updateBatchColour,
  } = useBatchGroup({ list: true });

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("name", {
      header: "Recipe Name",
      meta: {
        width: "30%",
      },
    }),
    columnHelper.accessor("bowl_capacity", {
      header: "Bowl Capacity",
      cell: ({ row }) => (
        <Stack direction="row">
          <Typography fontStyle={400} fontSize="14px">
            {row.original.bowl_capacity}
          </Typography>
          <Typography fontStyle={400} fontSize="14px" sx={{ ml: 0.5 }}>
            {row.original.bowl_capacity_unit}
          </Typography>
        </Stack>
      ),
    }),
    columnHelper.accessor("color", {
      header: "Colour",
      meta: {
        align: "center",
        width: "70px",
      },
      cell: ({ row }) => (
        <Box
          sx={{
            bgcolor: row.original.color,
          }}
          width="24px"
          height="24px"
          borderRadius="50%"
        />
      ),
    }),
    columnHelper.display({
      id: "actions",
      meta: {
        width: "50px",
      },
      cell: (props) => {
        const { row } = props;
        return (
          <Box
            component="img"
            src={editIcon}
            height={20}
            width={20}
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
              handleColourChange(true, row.original.color, row.original.id);
            }}
          />
        );
      },
    }),
  ];

  return (
    <>
      <CustomTable
        columns={columns}
        tableId="batchGroup"
        defaultData={listQuery?.data ?? []}
        headerText="Batch Groups"
        isLoading={listQuery?.isLoading}
        emptyTableMessage={
          "There is no batch group added yet, you need to add batch group first"
        }
        onRowLink={(e) => {
          return `/recipe/details/${e.id}?basic-details`;
        }}
        isInTab
      />

      <CustomeDialog
        open={batchGroup?.isEdit}
        title="Edit Colour Code"
        divider={false}
        content={
          <Stack minHeight="189px" width={{ sm: "360px", xs: "100%" }}>
            <BatchColourCodeDialog
              handleClose={handleColourChange}
              onSubmit={onUpdateBatchColour}
              colour={batchGroup?.colour}
              updateBatchColour={updateBatchColour}
            />
          </Stack>
        }
      />
    </>
  );
};
